const permissions = {
    read: 'Read',
    write: 'Write',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    share: 'Share',
    admin: 'Admin',
    owner: 'Owner',
    public: 'Public',
    private: 'Private',
    restricted: 'Restricted',
    loadFailed: 'Failed to load permissions',
    saveFailed: 'Failed to save permission',
    deleteFailed: 'Failed to remove permission',
    manageDescription: 'Manage who can access this document and what actions they can perform.',
    addPermission: 'Add Permission',
    editPermission: 'Edit Permission',
    noPermissions: 'No permissions set',
    noPermissionsDescription: 'Click "Add Permission" to grant access to users',
    entity: 'Entity',
    type: 'Type',
    grantedBy: 'Granted By',
    grantedDate: 'Granted Date',
    entityType: 'Entity Type',
    selectEntity: 'Select {{type}}',
    readDescription: 'Read - Can view the document',
    writeDescription: 'Write - Can edit the document',
    shareDescription: 'Share - Can share the document with others',
    deleteDescription: 'Delete - Can delete the document',
    types: {
      user: 'User',
      group: 'Group',
      tenant: 'Tenant',
    },
  };

export default permissions;
